import { render, staticRenderFns } from "./SU1SubColumn.vue?vue&type=template&id=178c1346&scoped=true"
import script from "./SU1SubColumn.vue?vue&type=script&lang=js"
export * from "./SU1SubColumn.vue?vue&type=script&lang=js"
import style0 from "./SU1SubColumn.vue?vue&type=style&index=0&id=178c1346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178c1346",
  null
  
)

export default component.exports